import type { MapDispatchToProps, MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import type { FormStateMap } from 'redux-form';
import { change, getFormAsyncErrors } from 'redux-form';
import { CONTACT_INFO_FORM_SECTION, contactFields } from '../../constants/formFields';
import type { Country } from '../../models';
import ContactForm from './ContactForm';
import type { PhoneType } from './Phone';

const { EMERGENCY_PHONE, PHONE } = contactFields;

interface ConnectedState {
  hasAsyncPhoneError: boolean;
  hasAsyncEmergencyPhoneError: boolean;
}

const mapStateToProps: MapStateToProps<ConnectedState, { form: string }, { form: FormStateMap }> = (
  state,
  { form },
) => {
  const asyncErrors: any = getFormAsyncErrors(form)(state);
  const asyncContactFormErrors =
    asyncErrors && asyncErrors[CONTACT_INFO_FORM_SECTION]
      ? asyncErrors[CONTACT_INFO_FORM_SECTION]
      : {};

  return {
    hasAsyncPhoneError: asyncContactFormErrors[PHONE] !== undefined,
    hasAsyncEmergencyPhoneError: asyncContactFormErrors[EMERGENCY_PHONE] !== undefined,
  };
};

interface ConnectedDispatch {
  onCountryChange: (phoneType: PhoneType) => void;
}

const mapDispatchToProps: MapDispatchToProps<
  ConnectedDispatch,
  {
    form: string;
    countries: Country[];
    shouldShowEmergencyContactInformation?: boolean;
  }
> = (dispatch, { form }) => ({
  onCountryChange(phoneType: PhoneType) {
    dispatch(change(form, `${CONTACT_INFO_FORM_SECTION}.${phoneType}`, ''));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
